import $axios from '~/plugins/axios';

import { Api, CampaignSplitFilter, CampaignSplitFilterRequest, DeleteCampaignSplitFilterIdParams, DeleteCampaignSplitFilterIdSplitProductsParams } from '~/api';
import { buildModule } from '../utils';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		filterById: {} as Dict<CampaignSplitFilter>,
	})
	.withGetters({
		byId: (state) => (id: number): CampaignSplitFilter | null => state.filterById[id] ?? null,
	})
	.withMutations({
		SET_FILTER (state, filter: CampaignSplitFilter) {
			state.filterById = { ...state.filterById, [filter.id]: filter };
		},
	})
	.withActions({
		async get ({ commit }, id: number) {
			const { data } = await api.get(`/campaign/split/filter/${ id }`);
			commit('SET_FILTER', data.payload);
		},
		async post ({ commit }, request: CampaignSplitFilterRequest) {
			const { data } = await api.post('/campaign/split/filter', request);
			commit('SET_FILTER', data.payload);
			return data.payload;
		},
		async update ({ commit }, { id, ...request }: { id: number } & CampaignSplitFilterRequest) {
			const { data } = await api.put(`/campaign/split/filter/${ id }`, request);
			commit('SET_FILTER', data.payload.filter);
			return data.payload;
		},
		async delete (_, { id, ...params }: { id: number } & DeleteCampaignSplitFilterIdParams) {
			const { data } = await api.delete(`/campaign/split/filter/${ id }`, { params });
			return data.payload;
		},
		async deleteSplitProducts (_, { id, ...params }: { id: number } & DeleteCampaignSplitFilterIdSplitProductsParams) {
			const { data } = await api.delete(`/campaign/split/filter/${ id }/split-products`, { params });
			return data.payload;
		},
	});


